export default __webpack_public_path__ + "static/media/amDotNetv1-5.ce79921d.jpg";